var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _JoltSubscription_instances, _JoltSubscription_connection, _JoltSubscription_fetchSubscribeToken, _JoltSubscription_retryTimeout, _JoltSubscription_claims, _JoltSubscription_logger, _JoltSubscription_subscribePromise, _JoltSubscription_registeredCallbacks, _JoltSubscription_webSocketTimeout, _JoltSubscription_subscribed, _JoltSubscription_autosubscribe, _JoltSubscription_boundCallbackCount_get, _JoltSubscription_sendAndConfirmSubscription;
import { retryable } from "./retryable";
export class JoltSubscription {
    constructor(connection, channelName, fetchSubscribeToken, { claims = {}, retryTimeout, logger, webSocketTimeout = 10000, autosubscribe = false, }) {
        _JoltSubscription_instances.add(this);
        _JoltSubscription_connection.set(this, void 0);
        _JoltSubscription_fetchSubscribeToken.set(this, void 0);
        _JoltSubscription_retryTimeout.set(this, void 0);
        _JoltSubscription_claims.set(this, void 0);
        _JoltSubscription_logger.set(this, void 0);
        _JoltSubscription_subscribePromise.set(this, void 0);
        _JoltSubscription_registeredCallbacks.set(this, void 0);
        _JoltSubscription_webSocketTimeout.set(this, void 0);
        _JoltSubscription_subscribed.set(this, void 0);
        _JoltSubscription_autosubscribe.set(this, false);
        // private
        _JoltSubscription_sendAndConfirmSubscription.set(this, (token, resolve, reject) => {
            let timeout = undefined;
            const clearHandlers = () => {
                timeout && clearTimeout(timeout);
                __classPrivateFieldGet(this, _JoltSubscription_connection, "f").removeEventListener("jolt.subscribed", handler);
                __classPrivateFieldGet(this, _JoltSubscription_connection, "f").removeEventListener("jolt.error", errorHandler);
            };
            const errorHandler = ({ detail: { channel, data: { message }, }, }) => {
                if (channel !== this.channel)
                    return;
                if (!message.startsWith("Subscription failed:"))
                    return;
                clearHandlers();
                __classPrivateFieldGet(this, _JoltSubscription_logger, "f").log(message);
                reject(false);
            };
            const handler = (event) => {
                if (event.detail.channel !== this.channel)
                    return;
                clearHandlers();
                __classPrivateFieldGet(this, _JoltSubscription_connection, "f").dispatchEvent(new CustomEvent("jolt.message", {
                    detail: { event: "jolt.subscribed", channel: this.channel },
                }));
                __classPrivateFieldSet(this, _JoltSubscription_subscribed, true, "f");
                resolve(true);
            };
            __classPrivateFieldGet(this, _JoltSubscription_connection, "f").addEventListener("jolt.subscribed", handler);
            __classPrivateFieldGet(this, _JoltSubscription_connection, "f").addEventListener("jolt.error", errorHandler);
            // Send the message to the WebSocket
            __classPrivateFieldGet(this, _JoltSubscription_connection, "f").send({
                event: "jolt.subscribe",
                channel: this.channel,
                data: { token },
            });
            timeout = setTimeout(() => {
                clearHandlers();
                __classPrivateFieldGet(this, _JoltSubscription_logger, "f").log(`WebSocket server timed out responding to subscribe request (took over ${__classPrivateFieldGet(this, _JoltSubscription_webSocketTimeout, "f")}ms).`);
                reject(false);
            }, __classPrivateFieldGet(this, _JoltSubscription_webSocketTimeout, "f"));
        });
        this._joltClientDisconnectedHandler = (ev) => {
            if (!__classPrivateFieldGet(this, _JoltSubscription_subscribed, "f"))
                return;
            __classPrivateFieldSet(this, _JoltSubscription_subscribePromise, undefined, "f");
            __classPrivateFieldSet(this, _JoltSubscription_subscribed, false, "f");
            if (ev.detail.intentional) {
                this._unbindAll();
                __classPrivateFieldGet(this, _JoltSubscription_connection, "f").removeEventListener("jolt-client.disconnected", this._joltClientDisconnectedHandler);
            }
            else {
                retryable(() => {
                    __classPrivateFieldSet(this, _JoltSubscription_subscribePromise, undefined, "f");
                    return this.subscribe();
                }, {
                    generateTimeout: __classPrivateFieldGet(this, _JoltSubscription_retryTimeout, "f"),
                    onError: (e, timeout) => {
                        __classPrivateFieldGet(this, _JoltSubscription_logger, "f").error(e);
                        __classPrivateFieldGet(this, _JoltSubscription_logger, "f").log(`Unable to reestablish subscription to ${this.channel}. Retrying in ${timeout}ms.`);
                    },
                });
            }
        };
        __classPrivateFieldSet(this, _JoltSubscription_connection, connection, "f");
        this.channel = channelName;
        __classPrivateFieldSet(this, _JoltSubscription_fetchSubscribeToken, fetchSubscribeToken, "f");
        __classPrivateFieldSet(this, _JoltSubscription_retryTimeout, retryTimeout, "f");
        __classPrivateFieldSet(this, _JoltSubscription_claims, claims, "f");
        __classPrivateFieldSet(this, _JoltSubscription_logger, logger, "f");
        __classPrivateFieldSet(this, _JoltSubscription_registeredCallbacks, {}, "f");
        __classPrivateFieldSet(this, _JoltSubscription_subscribed, false, "f");
        __classPrivateFieldSet(this, _JoltSubscription_webSocketTimeout, webSocketTimeout, "f");
        __classPrivateFieldSet(this, _JoltSubscription_autosubscribe, autosubscribe, "f");
    }
    /**
     * Binds a user-defined callback function to a specific event on the subscription channel.
     * The callback will be invoked whenever the specified event is received on the channel.
     *
     * @param event - The name of the event to bind the callback to. Supports wildcard `*` for matching multiple events.
     * @param callback - The user-defined callback function to be invoked when the event is received.
     * @returns A function that can be called to unbind the callback from the event.
     *
     * @example
     * ```typescript
     * const listener = (data) => {
     *   console.log('Message received:', data);
     * });
     * const unbindListener = subscription.bind('message.received', listener);
     *
     * // To unbind the callback
     * subscription.unbind('message.received', listener);
     * // OR
     * unbindListener()
     * ```
     */
    bind(event, callback) {
        var _a;
        const eventPatternString = event
            .replace(/[.+^$|]/g, "\\$&") // escape regex special characters
            .replace("*", ".*"); // replace `*` with `.*` for regex matching
        const eventPattern = new RegExp(`^${eventPatternString}$`);
        const wrappedCallback = (e) => {
            if (e.detail.channel === this.channel &&
                eventPattern.test(e.detail.event)) {
                callback(e.detail);
            }
        };
        __classPrivateFieldGet(this, _JoltSubscription_connection, "f").addEventListener("jolt.message", wrappedCallback);
        (_a = __classPrivateFieldGet(this, _JoltSubscription_registeredCallbacks, "f"))[event] || (_a[event] = new Map());
        __classPrivateFieldGet(this, _JoltSubscription_registeredCallbacks, "f")[event].set(callback, wrappedCallback);
        if (__classPrivateFieldGet(this, _JoltSubscription_autosubscribe, "f"))
            this.subscribe();
        return () => this.unbind(event, callback);
    }
    unbind(event, callback) {
        var _a;
        const wrappedCallback = (_a = __classPrivateFieldGet(this, _JoltSubscription_registeredCallbacks, "f")[event]) === null || _a === void 0 ? void 0 : _a.get(callback);
        if (wrappedCallback) {
            __classPrivateFieldGet(this, _JoltSubscription_connection, "f").removeEventListener("jolt.message", wrappedCallback);
            __classPrivateFieldGet(this, _JoltSubscription_registeredCallbacks, "f")[event].delete(callback);
            if (__classPrivateFieldGet(this, _JoltSubscription_autosubscribe, "f") && __classPrivateFieldGet(this, _JoltSubscription_instances, "a", _JoltSubscription_boundCallbackCount_get) === 0) {
                this.unsubscribe();
            }
        }
    }
    async send(payload) {
        await this.subscribe();
        __classPrivateFieldGet(this, _JoltSubscription_connection, "f").send({ ...payload, channel: this.channel });
    }
    subscribe() {
        if (__classPrivateFieldGet(this, _JoltSubscription_subscribePromise, "f"))
            return __classPrivateFieldGet(this, _JoltSubscription_subscribePromise, "f");
        return (__classPrivateFieldSet(this, _JoltSubscription_subscribePromise, new Promise((resolve, reject) => {
            this._ensureConnection();
            __classPrivateFieldGet(this, _JoltSubscription_connection, "f")
                .connect()
                .then(async (connectionId) => {
                const token = await this._subscribeToken(connectionId);
                return { connectionId, token };
            })
                .then(({ connectionId, token }) => {
                if (__classPrivateFieldGet(this, _JoltSubscription_connection, "f")._latestConnectionId !== connectionId) {
                    throw new NewConnectionDuringSubscriptionError();
                }
                __classPrivateFieldGet(this, _JoltSubscription_sendAndConfirmSubscription, "f").call(this, token, resolve, reject);
            })
                .catch((e) => {
                if (e instanceof NewConnectionDuringSubscriptionError) {
                    __classPrivateFieldGet(this, _JoltSubscription_logger, "f").error(e.message, "Retrying...");
                    __classPrivateFieldSet(this, _JoltSubscription_subscribePromise, undefined, "f");
                    resolve(this.subscribe());
                }
                reject(e);
            });
        }), "f"));
    }
    async promise() {
        return __classPrivateFieldGet(this, _JoltSubscription_subscribePromise, "f");
    }
    async unsubscribe() {
        this._unbindAll();
        if (__classPrivateFieldGet(this, _JoltSubscription_subscribePromise, "f")) {
            await __classPrivateFieldGet(this, _JoltSubscription_subscribePromise, "f");
            // We currently are not waiting to verify that the server received our unsubscribe request.
            // If we need verification, we will need to build in that functionality.
            __classPrivateFieldGet(this, _JoltSubscription_connection, "f").send({
                event: "jolt.unsubscribe",
                channel: this.channel,
                data: {},
            });
            __classPrivateFieldSet(this, _JoltSubscription_subscribePromise, undefined, "f");
        }
        __classPrivateFieldSet(this, _JoltSubscription_subscribed, false, "f");
        __classPrivateFieldGet(this, _JoltSubscription_connection, "f").removeEventListener("jolt-client.disconnected", this._joltClientDisconnectedHandler);
    }
    get subscribed() {
        return __classPrivateFieldGet(this, _JoltSubscription_subscribed, "f");
    }
    _ensureConnection() {
        __classPrivateFieldGet(this, _JoltSubscription_connection, "f").addEventListener("jolt-client.disconnected", this._joltClientDisconnectedHandler);
    }
    async _subscribeToken(connectionId) {
        return retryable(async () => await __classPrivateFieldGet(this, _JoltSubscription_fetchSubscribeToken, "f").call(this, this.channel, connectionId, {
            claims: __classPrivateFieldGet(this, _JoltSubscription_claims, "f"),
        }), {
            generateTimeout: __classPrivateFieldGet(this, _JoltSubscription_retryTimeout, "f"),
            onError: (e, timeout) => {
                __classPrivateFieldGet(this, _JoltSubscription_logger, "f").error(e);
                __classPrivateFieldGet(this, _JoltSubscription_logger, "f").log(`Could not fetch subscription token. Retrying in ${timeout}ms...`);
            },
        });
    }
    _unbindAll() {
        Object.values(__classPrivateFieldGet(this, _JoltSubscription_registeredCallbacks, "f")).forEach((callbackMap) => {
            callbackMap.forEach((callback) => {
                __classPrivateFieldGet(this, _JoltSubscription_connection, "f").removeEventListener("jolt.message", callback);
            });
        });
        __classPrivateFieldSet(this, _JoltSubscription_registeredCallbacks, {}, "f");
    }
}
_JoltSubscription_connection = new WeakMap(), _JoltSubscription_fetchSubscribeToken = new WeakMap(), _JoltSubscription_retryTimeout = new WeakMap(), _JoltSubscription_claims = new WeakMap(), _JoltSubscription_logger = new WeakMap(), _JoltSubscription_subscribePromise = new WeakMap(), _JoltSubscription_registeredCallbacks = new WeakMap(), _JoltSubscription_webSocketTimeout = new WeakMap(), _JoltSubscription_subscribed = new WeakMap(), _JoltSubscription_autosubscribe = new WeakMap(), _JoltSubscription_sendAndConfirmSubscription = new WeakMap(), _JoltSubscription_instances = new WeakSet(), _JoltSubscription_boundCallbackCount_get = function _JoltSubscription_boundCallbackCount_get() {
    return Object.values(__classPrivateFieldGet(this, _JoltSubscription_registeredCallbacks, "f")).reduce((total, callbackMap) => total + callbackMap.size, 0);
};
class NewConnectionDuringSubscriptionError extends Error {
    constructor() {
        super("A new connection has been established while attempting to subscribe.");
        this.name = this.constructor.name;
    }
}
//# sourceMappingURL=JoltSubscription.js.map